<template>
    <div>
        <div class="mb-15">
            <h3 class="text-28 text-md-20">자문단 답변 <span class="color-primary">{{ responses.length }}</span></h3>
        </div>

        <div class="mb-30">
            <div class="answer-items">
                <response v-model="value" v-for="response in responses" :key="response._id" :response="response" />
            </div>
        </div>
        <div>
            <div class="comment-card" v-if="isRequestee">
                <v-row class="row--small">
                    <v-col cols="12" md="10">
                        <v-textarea v-model="response.content" placeholder="답변을 입력하세요." light outlined class="white" hide-details clearable />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-row class="row--small ma-n1 ma-md-0 h-100">
                            <v-col cols="6" md="12">
                                <v-file-btn block outlined color="gray-9" @input="pushFile" class="h-100 h-md-36">첨부</v-file-btn>
                            </v-col>
                            <v-col cols="6" md="12">
                                <v-btn block color="primary" @click="save" class="h-100 h-md-36">등록</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <div class="mt-5">
                    <v-chip-group v-if="response.files.length" v-model="response.files" multiple column>
                        <v-chip outlined v-for="file in response.files" :key="file.name" :value="file">{{ file.name }}<v-icon small>mdi-close</v-icon></v-chip>
                    </v-chip-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";
import Response from "./response.vue";
import api from "@/api";
export default {
    components: { Response, VFileBtn },
    props: ["value"],
    computed: {
        responses() {
            return this.value.responses || [{}];
        },
        isRequestee() {
            return this.value?._requestees?.includes(this.$store.state.payload._user);
        },
    },
    data() {
        return {
            response: {
                _request: this.value._id,
                content: null,
                files: [],
            },
        };
    },
    methods: {
        pushFile(file) {
            const fileNames = this.response.files.map(({ name }) => name);

            if (!fileNames.includes(file.name)) this.response.files.push(file);
            else alert("동일한 이름의 파일이 있습니다.");
        },
        async save() {
            try {
                let { files, ...responseData } = this.response;
                const { counselResponse } = await api.v1.counsels.responses.post(responseData);

                files = await Promise.all(files.map(async (file) => (await api.v1.counsels.files.post({ _request: counselResponse._request, _response: counselResponse._id }, file)).file));

                counselResponse.files = files;
                counselResponse._files = files.map(({ _id }) => _id);

                alert("답변이 등록되었습니다");
                this.$emit("input", { ...this.value, _responses: [...(this.value._responses || []), counselResponse._id], responses: [...(this.value.responses || []), counselResponse] });
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style></style>
